export default "\n<!-- header -->\n<app-header></app-header>\n\n<router-outlet></router-outlet>\n\n<!-- footer -->\n<app-footer></app-footer>\n"